var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8319 1.17104C13.2702 -0.390348 10.7356 -0.390348 9.17395 1.17104L0 10.3432V16H5.65798L14.8319 6.82789C16.3894 5.27076 16.3894 2.73244 14.8319 1.17104ZM4.33096 12.8004L11.5506 5.58219L12.6814 6.71271L5.46596 13.9309L4.33096 12.8004ZM3.20021 11.6699L2.06947 10.5394L9.28915 3.32116L10.4199 4.45167L3.20021 11.6699ZM1.60011 12.3312L3.66958 14.4002H1.60011V12.3312ZM13.8036 5.56939L10.4327 2.19917C11.3757 1.38008 12.8009 1.40995 13.6969 2.30583C14.5972 3.19744 14.6228 4.62658 13.8036 5.56939Z",
    fill: "#EBBB59"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.59ed50c532dd3757c3b56635c6af1f46.svg";